export default __webpack_public_path__ + "static/06.02-0c993e3cf5b057e1709967171496b78b.png";